import { FC, useEffect, useState } from 'react';
import { Container, Dashboard } from './../../Registration.styles';
import { DashboardCard, Loading, Section } from '../../../../components';
import { SectionTitle, Separator } from '../../../my-account/MyAccount.styles';
import { getAdminDashboardResumo } from '../../../../services';
import { TDashboardAdminResumo } from '../../../../services/dashboard/dashboardDealer.types';
import { useToastStore } from '../../../../stores';
import { DashboardStatus } from '../../../../components/dashboard-card/DashboardCard';
import { useNavigate } from 'react-router-dom';

const RegistrationResume: FC = () => {
	const { setToast } = useToastStore();
	const navigate = useNavigate();
	const [loading, setLoading] = useState<boolean>(false);
	const [resume, setResume] = useState<TDashboardAdminResumo>();

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const response = await getAdminDashboardResumo();
				setResume(response);
			} catch {
				setToast({
					message: 'Erro ao buscar resumo!',
					variant: 'error',
				});
			} finally {
				setTimeout(() => setLoading(false), 500);
			}
		};

		fetchData();
	}, [setToast]);

	if (loading) return <Loading fullScreen />;

	return (
		<Container>
			<Section>
				<SectionTitle>Resumo</SectionTitle>
				<Separator />
				<Dashboard>
					<DashboardCard
						variant={DashboardStatus.ShopkeeperQty}
						amount={resume?.lojistasCadastrados ?? 0}
						onClick={() => navigate("/cadastros/lojistas")}
					/>
					<DashboardCard
						variant={DashboardStatus.ShopkeeperActiveQty}
						amount={resume?.lojistasAtivos ?? 0}
						onClick={() => navigate("/cadastros/lojistas")}
					/>
					<DashboardCard
						variant={DashboardStatus.ShopkeeperInactiveQty}
						amount={resume?.lojistasInativos ?? 0}
						onClick={() => navigate("/cadastros/lojistas")}
					/>
				</Dashboard>
				<Dashboard>
					<DashboardCard
						variant={DashboardStatus.GroupDealerQty}
						amount={resume?.gruposConcessionariaCadastrados ?? 0}
						onClick={() => navigate("/cadastros/grupo-concessionarias")}
					/>
					<DashboardCard
						variant={DashboardStatus.DealerQty}
						amount={resume?.concessionariaCadastrados ?? 0}
						onClick={() => navigate("/cadastros/concessionarias")}
					/>
					<DashboardCard
						variant={DashboardStatus.UserQty}
						amount={resume?.usuariosCadastrados ?? 0}
						onClick={() => navigate("/cadastros/usuarios")}
					/>
				</Dashboard>
			</Section>
		</Container>
	);
};

export default RegistrationResume;
